import type { WentOfflineAnonStatusDatagramBuf } from "~/classes/generated/status"

import { parseAnonymousIdBuf } from "~/utils/flatbuffers/anonymous"

const console = useLogger("status/went-offline-anon")

export function handleWentOfflineAnonStatusDatagramBuf(buf: WentOfflineAnonStatusDatagramBuf) {
  const { emitInterfaceEvent } = useEvents()
  const { cacheState } = useCache()

  const datagram: WentOfflineAnonStatusDatagram = {
    anonId: parseAnonymousIdBuf(buf.anonId()!),
    nextReconnectS: buf.nextReconnectS(),
  }

  console.warn("Cache was temporarily disconnected, will retry")
  cacheState.value.status = "pendingAnon"
  cacheState.value.nextReconnectDate = new Date(Date.now() + datagram.nextReconnectS * 1000)

  emitInterfaceEvent("wentOfflineAnonStatus", datagram)
}
